export default "__VITE_ASSET__c72d6651__"